export default "__VITE_ASSET__xm59VXBk__"